(function () {
    'use strict';

    angular
        .module('ib-checkin-services-module')
        .service('UpdateFlightsPassengerInfoService', UpdateFlightsPassengerInfoService);

    UpdateFlightsPassengerInfoService.$inject = ['$rootScope', '$location', '$q', 'CheckinAppConstants', '$window', '$cookies', 'PassengerAdditionalInfoService', 'ModalService', 'localStorageService', 'CkiDatalayerUtilsService', 'CkiDatalayerConstants', '$filter', 'FlightsPassengersUtils', 'CallAcceptService', 'IbCNewsletterService', 'UtilsService', 'FlightsPassengersTransformer'];

    function UpdateFlightsPassengerInfoService ($rootScope, $location, $q, CheckinAppConstants, $window, $cookies, PassengerAdditionalInfoService, ModalService, localStorageService, CkiDatalayerUtilsService, CkiDatalayerConstants, $filter, FlightsPassengersUtils, CallAcceptService, IbCNewsletterService, UtilsService, FlightsPassengersTransformer) {

        const self = this;
        self.updateFlightsPassengerInfo = updateFlightsPassengerInfo;
        self.updateApisInformation = updateApisInformation;


        ////////////////

        function updateFlightsPassengerInfo (passengersInfo, segmentsInfo, printBoardingCard, activeFields, selectedSegment, isEarly) {
            let nextStep;
            const isUserLogged = UtilsService.isUserLogged();
            const bookingInfo = localStorageService.get('bookingInfo');

            ModalService.isWaiting();

            if (selectedSegment) {
                nextStep = selectedSegment.whatToDo.selectedBlock.nextStep;
                if (nextStep === CheckinAppConstants.SHUTTLE_NEXT_STEPS.BOARDING_CARDS) {
                    printBoardingCard = true;
                }
                localStorageService.set('selectedBlockPa', selectedSegment);
            }

            const generalPassengersInfo = FlightsPassengersUtils.getPassengersUpdateInformation(passengersInfo, activeFields, selectedSegment);
            localStorageService.set('passengersAPIS', generalPassengersInfo.passengersApisIds);
            localStorageService.set('passengersNOAPIS', generalPassengersInfo.regularPassengersIds);
            localStorageService.set('passengersSelected', generalPassengersInfo.passengersSelected);

            const generalSegmentsInfo = FlightsPassengersUtils.getSegmentsUpdateInformation(segmentsInfo, selectedSegment);
            localStorageService.set('availableSegments', generalSegmentsInfo.selectedSegmentsIds);
            localStorageService.set('summaryTripForUpg', generalSegmentsInfo.summaryTrip);

            /* INIT DELETE GA4 MIGRATION*/
            const datalayerObject = {};
            datalayerObject[CkiDatalayerConstants.DATALAYER_INFO.ORIGIN_DESTINATIONS] = generalSegmentsInfo.summaryTrip;
            datalayerObject[CkiDatalayerConstants.DATALAYER_INFO.APIS_FULFILLED] = CkiDatalayerConstants.DATALAYER_VALUES.NO;
            CkiDatalayerUtilsService.addDataLayerInfo(datalayerObject);
            /* FIN DELETE GA4 MIGRATION*/
            const extendedDigitalDataInfo = {};
            extendedDigitalDataInfo[CkiDatalayerConstants.DIGITAL_DATA_INFO.ORIGIN_DESTINATIONS] = generalSegmentsInfo.summaryTrip;
            extendedDigitalDataInfo[CkiDatalayerConstants.DIGITAL_DATA_INFO.APIS_COMPLETED] = CkiDatalayerConstants.DATALAYER_VALUES.NO;
            CkiDatalayerUtilsService.addDigitalDataInfo(extendedDigitalDataInfo);

            updateNewsLetterInfo(generalPassengersInfo.newsLetterInfo.info);


            /**
             * Update the newesletter of passenger
             * @param {Array} newsLetterInfo List of passenger for updateNewsletter
             */
            function updateNewsLetterInfo (newsLetterInfo) {
                const emailSaved = {};

                if(!isUserLogged) {
                    for (let newsLetterIndex = 0; newsLetterIndex < newsLetterInfo.length; newsLetterIndex++) {
                        const infoToSave = generalPassengersInfo.newsLetterInfo.info[newsLetterIndex];
                        if (!emailSaved.hasOwnProperty(infoToSave.email)) {
                            IbCNewsletterService.putNewsletter(infoToSave).catch(() => { });
                            emailSaved[infoToSave.email] = true;
                        }
                    }
                }

                updateGeneralContactData();
            }

            function updateGeneralContactData () {
                if (generalPassengersInfo.additionalInfo.needsUpdate) {
                    updateAdditionalInfo(generalPassengersInfo.additionalInfo).then((data) => {
                        updateEmergencyInfo(generalPassengersInfo.emergencyInfo);
                    }, angular.noop);
                } else {
                    updateEmergencyInfo(generalPassengersInfo.emergencyInfo);
                }
            }

            /**
             * Send contact data of passenger to service
             * @param {Obj} additionalInfo Information of passenger for send to service
             */
            function updateAdditionalInfo (additionalInfo) {
                const defer = $q.defer();
                const isFreeType = angular.isDefined(bookingInfo?.outwardSegments[0]?.passengers[0]?.freeType);
                const dataTransformer = FlightsPassengersTransformer.updateAdditionalInfo(additionalInfo.info, isFreeType);
                const updateAdditionalInfoSuccess = (data) => {
                    defer.resolve();
                };
                const updateAdditionalInfoError = (error) => {
                    const isCheckFFError = error?.errorCode === 409 && error?.internalErrorCode === 'CHECK_FREQUENT_FLYER';
                    if (isCheckFFError) {
                        defer.reject();
                        ModalService.isNotWaiting();
                        $rootScope.$broadcast('validateFrequentFlyerEvent', error);
                    } else if (additionalInfo.isMandatory) {
                        defer.reject();
                        serviceError(error);
                    } else { defer.resolve(); }

                };
                PassengerAdditionalInfoService.updateAdditionalInfo(dataTransformer).then(updateAdditionalInfoSuccess, updateAdditionalInfoError);
                return defer.promise;
            }

            /**
             * Send emergency information to service
             * @param {Obj} emergencyInfo Information of passengers for send to service
             */
            function updateEmergencyInfo (emergencyInfo) {
                if (emergencyInfo.needsUpdate) {
                    PassengerAdditionalInfoService.updateEmergencyInfo(emergencyInfo.info).then(checkAcceptCall, (error) => {
                        if (emergencyInfo.isMandatory) {
                            serviceError(error);
                        } else {
                            checkAcceptCall();
                        }
                    });
                } else {
                    checkAcceptCall();
                }
            }

            function checkAcceptCall () {
                if (isCallAcceptServiceRequired()) {
                    CallAcceptService.callAccept(generalPassengersInfo.regularPassengersIds, printBoardingCard, nextStep, isEarly);
                } else {
                    continueToNextView();
                }

                function isCallAcceptServiceRequired () {
                    let callRequired = false;
                    if (generalPassengersInfo.passengersApisIds.length === 0 && nextStep !== CheckinAppConstants.SHUTTLE_NEXT_STEPS.FLY_NOW
                        && nextStep !== CheckinAppConstants.SHUTTLE_NEXT_STEPS.FLIGHT_PASSENGER && nextStep !== CheckinAppConstants.SHUTTLE_NEXT_STEPS.GDR) {
                        callRequired = true;
                    }
                    return callRequired;
                }
            }

            function continueToNextView () {
                if (generalPassengersInfo.passengersApisIds.length > 0) {
                    $location.path('/ibcoac2');
                } else if (nextStep === CheckinAppConstants.SHUTTLE_NEXT_STEPS.FLY_NOW) {
                    $location.path('/ibfnpa');
                } else if (nextStep === CheckinAppConstants.SHUTTLE_NEXT_STEPS.FLIGHT_PASSENGER) {
                    $location.path('/ibcoac');
                } else if (nextStep === CheckinAppConstants.SHUTTLE_NEXT_STEPS.GDR) {
                    $cookies.putObject(CheckinAppConstants.COOKIES.GDR_PA_INFO, {
                        flowId: localStorageService.get('flowId'),
                        fromStep: '/ibcoac'
                    }, { path: '/' });
                    $window.location.href = $filter('LinksFilter')('MANAGE_MY_BOOKING_LINK', CheckinAppConstants.lang) + '#!/chktrp?pnr=' + localStorageService.get('PNR') + '&surname=' + localStorageService.get('checkinSurname')
                        + '&segmentId=' + localStorageService.get('selectedBlockPa').id + '&isAirShuttle=true' + '&step=' + CheckinAppConstants.STEPS.GDR_CHANGE_FLIGHT;
                }
            }
        }

        /**
         * Open modal for show error to user
         * @param {Obj} error Error returned of service
         */
        function serviceError (error) {
            ModalService.isNotWaiting();
            ModalService.showGenericError(error, true).result.then($location.path('/ibcose'), $location.path('/ibcose'));
        }


        /**
         * @function
         * @name updateApisInformation
         * @desc make calls to update IBCOACII information and continue to next step, upgrading (ckiancupp) o ancillaries (ckianc)
         */
        function updateApisInformation (passengers) {
            let regularPassengers = localStorageService.get('passengersNOAPIS') || [];
            passengers = passengers || [];
            regularPassengers = regularPassengers.concat(passengers);
            localStorageService.set('passengersSelected', regularPassengers);
            CallAcceptService.callAccept(regularPassengers, false, null);
        }

    }
})();
